import {forkJoin, iif, Observable, of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {TranslateLoader} from "@ngx-translate/core";
import {InformationService} from "./information.service";
import {map} from "rxjs/operators";

export class CustomloaderService implements TranslateLoader{

  constructor(private http: HttpClient, private info: InformationService) {}

  getTranslation(lang: string): Observable<Object> {

    let domain = this.info.domain;
    let preferences = this.info.preferences;
    let i18n = !!preferences ? preferences["i18n"] : {};

    const path = 'assets/i18n/' + lang + '.json';
    const pathCustom = 'assets/i18n/' + domain + '/' + lang + '.json';

    return forkJoin([
      this.http.get(path, {responseType: 'json'}),
      iif(
        () => i18n && i18n[lang],
        this.http.get(pathCustom, {responseType: 'json'}),
        of({})
      )
    ]).pipe(
      map(([ labels, customLabels ]) => ({...labels, ...customLabels}))
    );
  }
}
